module.exports = __webpack_public_path__ + "img/kocht_ellwangen.cf16b34d.webp";